export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center object-top"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Artistic%20top%20down%20flat%20lay%20arrangement%20of%20carefully%20curated%20fashion%20and%20lifestyle%20items%20including%20neutral%20toned%20clothing%20accessories%20and%20decorative%20objects%20on%20a%20warm%20cream%20textured%20surface%2C%20soft%20diffused%20natural%20lighting%20from%20large%20window%2C%20Scandinavian%20minimal%20aesthetic%2C%20editorial%20photography%20with%20organic%20composition%2C%20beige%20sand%20and%20warm%20terracotta%20tones%2C%20calm%20and%20aspirational%20atmosphere%2C%20high%20resolution%20product%20still%20life&width=1920&height=1200&seq=kakobuy-hero-bg-v2-01&orientation=landscape')`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 pt-20 pb-16">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-foreground-700 mb-6">
              <span className="w-2 h-2 bg-accent-500 rounded-full animate-pulse"></span>
              Listy aktualizowane codziennie
            </div>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 text-balance">
              Kakobuy Spreadsheet
              <span className="block text-accent-300 text-2xl sm:text-3xl md:text-4xl lg:text-5xl mt-2">Polska 2026</span>
            </h1>

            <p className="text-base md:text-lg text-white/80 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0">
              Najlepsze listy produktów, znalezione okazje i przewodniki zakupowe Kakobuy w jednym miejscu.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 mb-10">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-full sm:w-auto px-8 py-3.5 text-sm font-semibold text-background-50 bg-accent-500 hover:bg-accent-600 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                Sprawdź Kakobuy Spreadsheet
              </a>
              <a
                href="#bezpieczenstwo"
                className="w-full sm:w-auto px-8 py-3.5 text-sm font-medium text-white border border-white/30 hover:border-white/60 hover:bg-white/10 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-center"
              >
                Dowiedz się, czy Kakobuy jest bezpieczny
              </a>
            </div>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6">
              {[
                'Aktualizowane listy produktów',
                'Przewodniki dla początkujących',
                'Analizy bezpieczeństwa',
                'Kategorie premium',
              ].map((text) => (
                <div
                  key={text}
                  className="flex items-center gap-1.5 text-xs text-white/70"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-check-line text-xs text-accent-400"></i>
                  </div>
                  {text}
                </div>
              ))}
            </div>
          </div>

          <div className="hidden lg:flex flex-1 justify-center">
            <div
              className="relative w-[420px] h-[340px] rounded-2xl overflow-hidden border border-white/15 shadow-2xl"
            >
              <img
                src="https://readdy.ai/api/search-image?query=A%20neatly%20organized%20product%20catalog%20grid%20featuring%20fashion%20and%20accessory%20items%20photographed%20from%20above%20on%20a%20warm%20sand%20colored%20surface%2C%20clean%20minimal%20layout%20with%20soft%20natural%20shadows%2C%20editorial%20ecommerce%20dashboard%20aesthetic%2C%20neutral%20cream%20and%20beige%20tones%20throughout%2C%20organized%20sections%20with%20subtle%20labels%2C%20modern%20clean%20interface%20design%20inspiration%2C%20high%20quality%20flat%20lay%20photography&width=840&height=680&seq=kakobuy-hero-card-v2-01&orientation=landscape"
                alt="Kakobuy Spreadsheet - Przegląd produktów"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-5">
                <p className="text-white text-sm font-medium">Przeglądaj najnowsze produkty</p>
                <p className="text-white/60 text-xs mt-1">Ponad 10 000 produktów w bazie</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}